export default {
  name: 'LiveCard',
  props: {
    liveData: Object,
    menu: Object,
    liveCount: Number // 直播数量

  },

  data() {
    return {
      status: 0 // 2 直播中

    };
  },

  methods: {
    goDetail(id) {
      window.open(`/liveDetail.html?menuId=${this.menu.id}&name=${this.menu.menu_name}&id=${id}`);
    }

  }
};